import React from 'react';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { FcCancel } from "react-icons/fc";
import { FiEdit } from "react-icons/fi";
import { VscSave } from "react-icons/vsc";
import { FcCancel as FcCancel1 } from "react-icons/fc";
import config from '../../config';
import loadingImg from "../../assets/loading.gif"
/* import {Random, MersenneTwister19937} from 'random-js'; */

const ImportTrades = () => {
    const companyId = useSelector((state) => state.user.companyId);
    const [baskets, setBaskets] = useState([]);
    const [err, setErr] = useState("");
    const [errSuccess, setErrSuccess] = useState("");
    const [file, setFile] = useState(null);
    const [basketId, setBasketId] = useState(0);
    const [isloading, setIsloading] = useState(false)

    const getBaskets = async (e) => {

        try {


            //const res = await axios.post(config.BL_API_URL+"/api/baskets/getBaskets", inputs)
            //const res = await axios.get(config.BL_API_URL+"/basket/v1");
            const res = await axios.get(config.BL_API_URL + "/basket/v1/getBasketByCompanyId/" + companyId);
            //console.log(res.data)

            if (res.data)
                setBaskets(res.data)
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }
    useEffect(() => {
        getBaskets(companyId)
    }, [companyId])
    const handleFileSelection = (e) => {
        const file = e.target.files[0];

        setFile(file);
    };
    const handleChange = (e) => {
        if (e.target.id === 'basketId') {

            setBasketId(e.target.value)
        }
        
    }

    const upload = async () => {

        setErrSuccess("");
        setErr("");
        setIsloading(true)
        const formData = new FormData();


        formData.append("basketId", Number(basketId));
        formData.append("file", file);

        axios.post(config.BL_API_URL + "/Processes/v1/uploadOrderResponse", formData).then((res) => {
            setIsloading(false);

            setErrSuccess(res.data);
        }).catch((err) => {
            setIsloading(false);
            setErr("Error uploading file " + err);
        });



    };

    return (
        <div>
            <div className="my-14 md:px-14 p-2 max-w-screen-xl mx-auto ">
                <div className="flex flex-col">
                    <div className="-m-1.5 overflow-x-auto">
                        <div className="border rounded-lg divide-y divide-gray-200 py-5">
                            <div className='col-span-2'>
                                <div className=" col-span-2">
                                    
                                    <div className="overflow-hidden">
                                        <div className="overflow-hidden">
                                            <table className="min-w-full divide-y divide-gray-200 justify-center  ">
                                                <thead className="bg-gray-50 ">
                                                    <tr>
                                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">Basket Name</th>
                                                        <th scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {baskets &&
                                                        baskets.map((basket) => (
                                                    <tr>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                        <select
                                                                onChange={handleChange}
                                                                name="basketName" id="basketId"
                                                                className="py-2 px-3 pe-9 block min-w-full w-full sm:w-auto border-gray-200 shadow-sm -mt-px -ms-px rounded-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none ">
                                                                <option value="-">- Select -</option>
                                                                {baskets && (
                                                                    baskets.map((basket, index) => <option key={basket.id} value={basket.basketId}>{basket.name}</option>)
                                                                )}
                                                            </select>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className="text-sm text-gray-900">
                                                                <div className='row-span-1 flex justify-left py-1 '>
                                                                    <div className='col-span-1'>
                                                                        <input type="file" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onChange={e => handleFileSelection(e)} />
                                                                    </div>
                                                                </div>

                                                                <div className='row-span-1 flex justify-left py-1'>
                                                                    <div className='col-span-1'>
                                                                        <button className="bg-blue-500 hover:bg-blue-700 text-white  font-bold py-2 px-4 rounded" onClick={e => upload(e)} >Import
                                                                            <span className="flex gap-2 items-center justify-left">
                                                                                {isloading &&
                                                                                    <img src={loadingImg} alt="Icon" className="w-6 text-left" />
                                                                                }
                                                                            </span>
                                                                        </button>

                                                                        <p className="text-red-400 mt-8">
                                                                            {err}
                                                                        </p>
                                                                        <p className="text-black-400 mt-8">
                                                                            {errSuccess}
                                                                        </p>


                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </td>F
                                                    </tr>
                                                        ))}
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ImportTrades;